export default defineNuxtRouteMiddleware(async (to, from) => {
  if (process.server) {
    return;
  }

  if (window.localStorage.getItem("saveUrl")) {
    const url = window.localStorage.getItem("saveUrl");
    window.localStorage.removeItem("saveUrl");
    window.location.replace(url);
  }

  const { $auth0JS } = useNuxtApp();
  const baseStore = useBaseStore();
  const userStore = useUserStore();
  const authStore = useAuthStore();
  const resultCheckAuth0 = await $auth0JS.checkSession();
  if (resultCheckAuth0) {
    if (!$auth0JS.user.company_en) {
      window.location.replace('/?error=company_en_required')
    } else if (to.query.error === "expired_terms") {
      window.location.replace('/?error=expired_terms&auth0_id=' + encodeURIComponent($auth0JS.user.sub));
    }
    await baseStore
      .getUserMe()
      .then(async (res) => {
        let userData = res;
        if (
          !to.name.includes("company-create") &&
          userData.userRole === 16010 &&
          !userData.companyName
        ) {
          window.location.replace('/company/create?invited=true&manager=true');
        }
        if (
          $auth0JS.user.lang.code !== userData.basicLanguage ||
          $auth0JS.user.industry.code !== userData.companyType
        ) {
          const result = await baseStore.createYBSession({
            id_token: $auth0JS.id_token,
          });
          userData = result.data;
        }
        if (userData !== $auth0JS.user) {
          if (userData.userType !== $auth0JS.user.userType) {
            baseStore.$patch({ failToRefreshToken: true });
          }
          authStore.$patch({ user: userData });
          baseStore.$patch({ isAuthenticated: true });
          userData.userType = await baseStore.getUserType(userData.userType);
          userStore.$patch({
            type: userData.userType,
            position: userData.userRole,
          });
        }
      })
      .catch(() => {
        baseStore.$patch({ failToRefreshToken: true });
        return abortNavigation();
      });
  } else {
    if (
      to.fullPath.includes("yarn") ||
      to.fullPath.includes("supplier") ||
      to.fullPath.includes("downloadblock")
    ) {
      window.localStorage.setItem("saveUrl", to.fullPath);
    }
    return navigateTo({ path: "/login"});
  }
});
